//GeneratorFlag:[NoChange]
import PersonVehicle from './person-vehicle';

export default {PersonVehicle}
export{PersonVehicle}